import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'bags-20kg-only-web-app-modal',
    templateUrl: './bags-20kg-only-web-app-modal.component.html',
    styleUrls: ['./bags-20kg-only-web-app-modal.component.scss'],
    standalone: false
})
export class Bags20kgOnlyWebAppModalComponent implements OnInit {

  constructor(public modal: NgbActiveModal) { }

  ngOnInit() {
  }

  onClose() {
    this.modal.close();
  }

}
